import type {
  BidSummary,
  PublishedTaskDetail,
  PublishedTaskListResponse,
  PublishedTaskQuery,
} from '@/types/userCenter/publishedTask'
import { httpClient } from '@/utils/request'

/**
 * 发布管理 API
 * 雇主视角 - 管理自己发布的任务
 * V6 统一路径规范
 */
export const publishedTasksApi = {
  /**
   * 获取我发布的任务列表
   * V6: /users/me/tasks/published
   */
  getPublishedTasks(params: PublishedTaskQuery) {
    return httpClient.get<PublishedTaskListResponse>('/users/me/tasks/published', { params })
  },

  /**
   * 获取任务详情
   * V6: /tasks/{id}
   */
  async getTaskDetail(id: string): Promise<PublishedTaskDetail> {
    const res = await httpClient.get<any>(`/tasks/${id}`)
    if (res && res.task) {
      const status = res.task.status?.toUpperCase()
      return {
        ...res.task,
        status,
        publisher: res.publisher || res.task.publisher,
        attachments: res.attachments || res.task.attachments,
        milestones: res.milestones || res.task.milestones,
        bids: res.bids || res.task.bids,
        bid_count: res.bid_count !== undefined ? res.bid_count : res.task.bid_count,
      } as PublishedTaskDetail
    }
    if (res && res.status) {
      res.status = res.status.toUpperCase()
    }
    return res as PublishedTaskDetail
  },

  /**
   * 获取任务投标列表
   * V6: /tasks/{id}/bids
   */
  getTaskBids(id: string) {
    return httpClient.get<BidSummary[]>(`/tasks/${id}/bids`)
  },

  /**
   * 选标
   * V6 RESTful: /tasks/{id}/bids/{bidId}/select
   */
  selectBid(id: string, bidId: string) {
    return httpClient.post<void>(`/tasks/${id}/bids/${bidId}/select`)
  },

  /**
   * 终止任务
   * RESTful: POST /tasks/{id}/actions/terminate
   */
  terminateTask(id: string) {
    return httpClient.post<void>(`/tasks/${id}/actions/terminate`)
  },
}
